window.initDateRangePicker = function(id, callback) {
    $("#"+id+"_range").daterangepicker({
        "applyButtonClasses": "btn-success",
        "autoUpdateInput": false,
        "linkedCalendars": false,
        "locale": locale
    });
    let range = $("#"+id+"_range").val();
    if (range.length > 0) {
        $("#"+id+"_range").closest('div.form-group').find('.reset-daterangepicker').show();
    }
    $("#"+id+"_range").on("apply.daterangepicker", function(ev, picker) {
        if (picker.startDate && picker.endDate) {
            $("#"+id+"_range").val(picker.startDate.format(daterangepicker_format)+" / "+picker.endDate.format(daterangepicker_format));
            $("#"+id+"_from").val(picker.startDate.format(daterangepicker_format));
            $("#"+id+"_to").val(picker.endDate.format(daterangepicker_format));
        }
        $("#"+id+"_range").closest('div.form-group').find('.reset-daterangepicker').show();
        if (typeof callback !== typeof undefined) {
            let fn = window[callback];
            if (typeof fn === "function") {
                fn();
            }
        }
    });
    $("#"+id+"_range").on("cancel.daterangepicker", function() {
        let today = new Date();
        $("#"+id+"_range").data('daterangepicker').setStartDate(today);
        $("#"+id+"_range").data('daterangepicker').setEndDate(today);
        $("#"+id+"_range").val('');
        $("#"+id+"_from").val('');
        $("#"+id+"_to").val('');
        $("#"+id+"_range").closest('div.form-group').find('.reset-daterangepicker').hide();
        if (typeof callback !== typeof undefined) {
            let fn = window[callback];
            if (typeof fn === "function") {
                fn();
            }
        }
    });
    $(document).on("keyup", "#"+id+"_range", function() {
        if ($(this).val().length == 0) {
            let today = new Date();
            $("#"+id+"_range").data('daterangepicker').setStartDate(today);
            $("#"+id+"_range").data('daterangepicker').setEndDate(today);
            $("#"+id+"_range").val('');
            $("#"+id+"_from").val('');
            $("#"+id+"_to").val('');
            $("#"+id+"_range").data('daterangepicker').hide();
            $("#"+id+"_range").closest('div.form-group').find('.reset-daterangepicker').hide();
            if (typeof callback !== typeof undefined) {
                let fn = window[callback];
                if (typeof fn === "function") {
                    fn();
                }
            }
        }
    });
};

$(function() {
    $(document).on("click", ".reset-daterangepicker", function() {
        let id = $(this).attr('data-id');
        let callback = $(this).attr('data-callback');
        let today = new Date();
        $("#"+id+"_range").data('daterangepicker').setStartDate(today);
        $("#"+id+"_range").data('daterangepicker').setEndDate(today);
        $("#"+id+"_range").val('');
        $("#"+id+"_from").val('');
        $("#"+id+"_to").val('');
        $("#"+id+"_range").data('daterangepicker').hide();
        $("#"+id+"_range").closest('div.form-group').find('.reset-daterangepicker').hide();
        if (typeof callback !== typeof undefined) {
            let fn = window[callback];
            if (typeof fn === "function") {
                fn();
            }
        }
    });
});
